












































// Incluimos los mensajes de este módulo
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import GlobalMixin from "@/mixins/global";

export default GlobalMixin.extend({
  props: ["search", "proveedor", "stps", "patronal", "statusSelect"],
  data: () => ({
    headerContractList: [],
    items: [],
    moduleName: "DATATABLE_CONTRACT",
    headerProps: {
      sortByText: "Ordenar por",
    },
    footerProps: {
      itemsPerPageText: "Registros por página",
      itemsPerPageAllText: "Todos",
      pageText: "{0}-{1} de {2}",
      sortByText: "Ordenar por",
    },
    loadingText: "Cargando... Por favor espere",
    noDataText: "Sin datos",
    loading: true,
  }),
  methods: {
    ini() {
      //Datatable de la lista de contrato
      (this.headerContractList = [
        {
          text: "Proveedor",
          value: "proveedor",
          align: "start",
          filter: this.getfilterProveedor,
        },
        {
          text: "Es Obra",
          value: "proveedorObra",
          template: this.getObra,
        },
        {
          text: "Registro STPS",
          value: "registroSTPS",
          filter: this.getfilterSTSP,
        },
        {
          text: "Registro Patronal",
          value: "registroPatronal",
          filter: this.getfilterPatronal,
        },
        {
          text: "Estatus",
          value: "estatus",
          align: " d-none",
          filter: this.getfilterEstatus,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ]),
        //Obtiene la lista de contratos
        this.getContractList();
    },
    getContractList() {
      let isAuthorizerObra =
        this.$store.getters["auth/rol"] == "2" ? true : false;
      let isAdmin = ["4", "5"].includes(this.$store.getters["auth/rol"]) ? true : false;
      dataService
        .getContractList()
        .then((Response: ResponseData) => {
          if (Response.data.data[0]) {
            Response.data.data[0].forEach((itemR: any) => {
              if (isAdmin) {
                this.items.push(itemR);
              } else {
                if (itemR.proveedorObra && isAuthorizerObra) {
                  this.items.push(itemR);
                } else if (!itemR.proveedorObra && !isAuthorizerObra) {
                  this.items.push(itemR);
                }
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // FILTROS
    getfilterProveedor(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.proveedor) {
        return true;
      }
      let noProveedor = this.proveedor.userID;
      let values = value.toString();
      return values.toLowerCase().includes(noProveedor.toLowerCase());
    },
    getfilterSTSP(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.stps) {
        return true;
      }
      let values = value.toString();
      return values.toLowerCase().includes(this.stps.toLowerCase());
    },
    getfilterPatronal(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.patronal) {
        return true;
      }
      let values = value.toString();
      return values.toLowerCase().includes(this.patronal.toLowerCase());
    },
    getfilterEstatus(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.statusSelect) {
        return true;
      }
      return value.includes(this.statusSelect.id);
    },
    getObra(value: boolean) {
      switch (value) {
        case true:
          return "Si";
          break;
        case false:
          return "No";
          break;
        default:
          return "N/A";
          break;
      }
    },
  },
  mounted() {
    this.ini();
  },
});
